const COOKIE_KEY = {
  VERSION_IDENTIFIER: "FlexTeam-Version",
  AID: "AID",
  WS_AID: "V2_WS_AID",
  WS_RID: "V2_WS_RID",
  WS_FFA: "V2_WS_FFA",
  DEVICE_ID: "DEVICE_ID",
  CURRENT_CUSTOMER_INFO: "V2_CUSTOMER_INFO",
  LOCALE: "FlexTeam-Locale",
  LOGIN_ERROR_MESSAGE: "V2_LOGIN_ERROR"
};
const HEADER_KEY = {
  REAUTH_TOKEN: "x-flex-ffa",
  API_ACCESS_TOKEN: "x-flex-aid",
  REQUEST_TIME: "x-request-time",
  MF_APP_NAME: "flexteam-mf-appname",
  MF_APP_VERSION: "flexteam-mf-appversion",
  DEVICE_ID: "flexteam-deviceid",
  /**
   * {@link FlexProductCode}
   */
  PRODUCT_CODE: "flexteam-productcode",
  LOCALE: "FlexTeam-Locale"
};
const COOKIE_MAX_AGE = 400 * 60 * 60 * 24;
const DEFAULT_COOKIE_OPTIONS = { path: "/", sameSite: "lax" };
const DEFERRED_DEFAULT_TIMEOUT = 3e3;
const isTest = process.env.NODE_ENV === "test";
const isServer = typeof window === "undefined";
const FlexProductCode = {
  Flex: "FLEX",
  CareerSite: "CAREERSITE"
};
const SESSION_CHANGE_MESSAGE = {
  KEY: "session_message",
  SIGN_OUT: "signedOut",
  TIMEOUT: "timedOut",
  CHANGE: "changed"
};

export { COOKIE_KEY, COOKIE_MAX_AGE, DEFAULT_COOKIE_OPTIONS, DEFERRED_DEFAULT_TIMEOUT, FlexProductCode, HEADER_KEY, SESSION_CHANGE_MESSAGE, isServer, isTest };
//# sourceMappingURL=constants.mjs.map
